'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var logger = require('../../utils/logger.js');
var RequiredIndicator = require('./RequiredIndicator.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var _excluded = ["className", "children", "isMandatory", "requiredIndicator", "isRequired"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Used to enhance the usability of form controls.
 *
 * It is used to inform users as to what information
 * is requested for a form field.
 *
 * ♿️ Accessibility: Every form field should have a form label.
 */
var Label = react.forwardRef(function (passedProps, ref) {
  var _field$getLabelProps;
  var styles = react.useStyleConfig('Label', passedProps);
  var props = react.omitThemingProps(passedProps);
  props.className;
  var children = props.children,
    isMandatory = props.isMandatory,
    _props$requiredIndica = props.requiredIndicator,
    requiredIndicator = _props$requiredIndica === void 0 ? /*#__PURE__*/React__namespace.createElement(RequiredIndicator.RequiredIndicator, null) : _props$requiredIndica,
    _props$isRequired = props.isRequired,
    isRequired = _props$isRequired === void 0 ? isMandatory : _props$isRequired,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  React.useEffect(function () {
    logger.warn('`isMandatory` is deprecated and will be removed in the future. Use `isRequired`.', 'Label', isMandatory !== undefined);
  }, [isMandatory]);
  var field = react.useFormControlContext();
  var ownProps = (_field$getLabelProps = field === null || field === void 0 ? void 0 : field.getLabelProps(rest, ref)) !== null && _field$getLabelProps !== void 0 ? _field$getLabelProps : _objectSpread({
    ref: ref
  }, rest);
  return /*#__PURE__*/React__namespace.createElement(react.chakra.label, _extends__default["default"]({}, ownProps, {
    className: utils.cx('chakra-label', props.className),
    __css: _objectSpread({
      display: 'block',
      textAlign: 'start'
    }, styles)
  }), children, isRequired || field !== null && field !== void 0 && field.isRequired ? requiredIndicator : null);
});
Label.displayName = 'Label';
exports.Label = Label;